<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>
      <div class="nav-item active">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconliebiao"></i>
          </div>
        </div>
        广告管理
      </div>
    </div>
    <div class="right">
      <div>
        <div class="right-title">
          <span>广告管理</span>
        </div>
        <div class="content-box">
          <div class="bannet-list-box">
            <p class="banner-box-title">候选人广告</p>
            <div class="banner-item">
              <div class="item">
                <span>广告图片1</span>
                <el-upload
                  class="avatar-uploader"
                  accept="image/*"
                  action=""
                  multiple
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload1">
                  <img v-if="imageUrl1" :src="config.urlStr + '/' + imageUrl1" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸586*184</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl1" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(1)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片2</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload2">
                  <img v-if="imageUrl2" :src="config.urlStr + '/' + imageUrl2" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸586*184</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl2" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;" @click="save(2)">保存</el-button>
          </div>
          <div class="bannet-list-box">
            <p class="banner-box-title">机构广告</p>
            <div class="banner-item">
              <div class="item">
                <span>广告图片1</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload3">
                  <img v-if="imageUrl3" :src="config.urlStr + '/' + imageUrl3" class="avatar3">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸1200*200</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl3" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;" @click="save(3)">保存</el-button>
          </div>
          <div class="bannet-list-box bannet-list-boxh5 ">
            <p class="banner-box-title">手机广告</p>
            <div class="banner-item">
              <div class="item">
                <span>广告图片1</span>
                <el-upload
                  class="avatar-uploader"
                  accept="image/*"
                  action=""
                  multiple
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload4">
                  <img v-if="imageUrl4" :src="config.urlStr + '/' + imageUrl4" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl4" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(4)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片2</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload5">
                  <img v-if="imageUrl5" :src="config.urlStr + '/' + imageUrl5" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl5" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(5)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片3</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload6">
                  <img v-if="imageUrl6" :src="config.urlStr + '/' + imageUrl6" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl6" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(6)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片4</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload7">
                  <img v-if="imageUrl7" :src="config.urlStr + '/' + imageUrl7" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl7" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(7)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片5</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload8">
                  <img v-if="imageUrl8" :src="config.urlStr + '/' + imageUrl8" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl8" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(8)">保存
            </el-button>
          </div>


          <div class="bannet-list-box bannet-list-boxh5 ">
            <p class="banner-box-title">社工协会手机广告</p>
            <div class="banner-item">
              <div class="item">
                <span>广告图片1</span>
                <el-upload
                  class="avatar-uploader"
                  accept="image/*"
                  action=""
                  multiple
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload9">
                  <img v-if="imageUrl9" :src="config.urlStr + '/' + imageUrl9" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl9" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(9)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片2</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload10">
                  <img v-if="imageUrl10" :src="config.urlStr + '/' + imageUrl10" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl10" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(10)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片3</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload11">
                  <img v-if="imageUrl11" :src="config.urlStr + '/' + imageUrl11" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl11" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(11)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片4</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload12">
                  <img v-if="imageUrl12" :src="config.urlStr + '/' + imageUrl12" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl12" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(12)">保存
            </el-button>
            <div class="banner-item">
              <div class="item">
                <span>广告图片5</span>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload13">
                  <img v-if="imageUrl13" :src="config.urlStr + '/' + imageUrl13" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span style="color: #999;width: 200px;">图片建议尺寸394*140</span>
              </div>
              <div class="item">
                <span>链接地址</span>
                <el-input v-model="bannerUrl13" placeholder="请输入链接地址" style="width: 800px;"></el-input>
              </div>
            </div>
            <el-button type="primary" style="display: block;width: 150px;margin-bottom: 20px;" @click="save(13)">保存
            </el-button>
          </div>


        </div>
        <footerBox class="footer footer-box "/>
      </div>
    </div>
  </div>
</template>

<script>
  import footerBox from './components/rightBottom'
  import config from '../../../config/index'

  export default {
    name: "rzrAdmin",
    data() {
      return {
        config: config,
        imageUrl1: '',
        bannerUrl1: '',
        imageUrl2: '',
        bannerUrl2: '',
        imageUrl3: '',
        bannerUrl3: '',
        imageUrl4: '',
        bannerUrl4: '',
        imageUrl5: '',
        bannerUrl5: '',
        imageUrl6: '',
        bannerUrl6: '',
        imageUrl7: '',
        bannerUrl7: '',
        imageUrl8: '',
        bannerUrl8: '',
        imageUrl9: '',
        bannerUrl9: '',
        imageUrl10: '',
        bannerUrl10: '',
        imageUrl11: '',
        bannerUrl11: '',
        imageUrl12: '',
        bannerUrl12: '',
        imageUrl13: '',
        bannerUrl13: '',
      }
    },
    created() {
      this.$store.state.topNav = 8
      this.getBanner()
    },
    methods: {
      getBanner() {
        this.$api.apiContent.advertisement({
          admin_id: this.$store.state.user.id
        }).then(res => {
          res.data.map(item => {
            if (item.position === 1) {
              this.imageUrl1 = item.ad_file
              this.bannerUrl1 = item.url
            } else if (item.position === 2) {
              this.imageUrl2 = item.ad_file
              this.bannerUrl2 = item.url
            } else if (item.position === 3) {
              this.imageUrl3 = item.ad_file
              this.bannerUrl3 = item.url
            } else if (item.position === 4) {
              this.imageUrl4 = item.ad_file
              this.bannerUrl4 = item.url
            } else if (item.position === 5) {
              this.imageUrl5 = item.ad_file
              this.bannerUrl5 = item.url
            } else if (item.position === 6) {
              this.imageUrl6 = item.ad_file
              this.bannerUrl6 = item.url
            } else if (item.position === 7) {
              this.imageUrl7 = item.ad_file
              this.bannerUrl7 = item.url
            } else if (item.position === 8) {
              this.imageUrl8 = item.ad_file
              this.bannerUrl8 = item.url
            } else if (item.position === 9) {
              this.imageUrl9 = item.ad_file
              this.bannerUrl9 = item.url
            } else if (item.position === 10) {
              this.imageUrl10 = item.ad_file
              this.bannerUrl10 = item.url
            } else if (item.position === 11) {
              this.imageUrl11 = item.ad_file
              this.bannerUrl11 = item.url
            } else if (item.position === 12) {
              this.imageUrl12 = item.ad_file
              this.bannerUrl12 = item.url
            } else if (item.position === 13) {
              this.imageUrl13 = item.ad_file
              this.bannerUrl13 = item.url
            }

          })
        }).catch()
      },

      beforeAvatarUpload1(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl1 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload2(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl2 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload3(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl3 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload4(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl4 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload5(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl5 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload6(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl6 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload7(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl7 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload8(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl8 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },

      beforeAvatarUpload9(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl9 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },

      beforeAvatarUpload10(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl10 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload11(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl11 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload12(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl12 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },
      beforeAvatarUpload13(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        let fd = new window.FormData();
        fd.append('image', file)
        fd.append('admin_id', this.$store.state.user.id)
        console.log(fd)
        this.$api.apiContent.file(fd).then(res => {
          this.imageUrl13 = res.data
        }).catch(e => {
          console.log(e)
          this.$message.error(e.info)
        })
      },


      save(num) {
        let url = ''
        let ad_file = ''

        if (num === 1) {
          url = this.bannerUrl1
          ad_file = this.imageUrl1
        } else if (num === 2) {
          url = this.bannerUrl2
          ad_file = this.imageUrl2
        } else if (num === 3) {
          url = this.bannerUrl3
          ad_file = this.imageUrl3
        } else if (num === 4) {
          url = this.bannerUrl4
          ad_file = this.imageUrl4
        } else if (num === 5) {
          url = this.bannerUrl5
          ad_file = this.imageUrl5
        } else if (num === 6) {
          url = this.bannerUrl6
          ad_file = this.imageUrl6
        } else if (num === 7) {
          url = this.bannerUrl7
          ad_file = this.imageUrl7
        } else if (num === 8) {
          url = this.bannerUrl8
          ad_file = this.imageUrl8
        } else if (num === 9) {
          url = this.bannerUrl9
          ad_file = this.imageUrl9
        } else if (num === 10) {
          url = this.bannerUrl10
          ad_file = this.imageUrl10
        } else if (num === 11) {
          url = this.bannerUrl11
          ad_file = this.imageUrl11
        }else if(num === 12){
          url = this.bannerUrl12
          ad_file = this.imageUrl12
        }else if(num === 13){
          url = this.bannerUrl13
          ad_file = this.imageUrl13
        }
        this.$api.apiContent.saveBanner({
          admin_id: this.$store.state.user.id,
          position: num,
          url: url,
          ad_file: ad_file
        }).then(res => {
          this.$message.success(res.info)
          this.getBanner()
        })
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .bannet-list-box {
    margin-bottom: 20px;

    .banner-box-title {
      font-size: 16px;
      line-height: 32px;
      color: #00a2ea;
      border-bottom: 1px solid #00a2ea;
      margin-bottom: 20px;
    }

    .banner-item {
      /*display: flex;*/
      /*align-items: center;*/
      .item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        > span {
          display: block;
          width: 120px;
          text-align: center;
          line-height: 40px;
        }
      }
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 586px;
    height: 140px;
    line-height: 140px;
    text-align: center;
    border: 1px dashed #8c939d;
  }

  .avatar {
    width: 586px;
    height: 140px;
    display: block;
  }

  .avatar3 {
    width: 600px;
    height: 100px;
    display: block;
  }

  .bannet-list-boxh5 .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 394px;
    height: 140px;
    line-height: 140px;
    text-align: center;
    border: 1px dashed #8c939d;
  }

  .bannet-list-boxh5 .avatar {
    width: 394px;
    height: 140px;
    display: block;
  }

  .bannet-list-boxh5 .avatar3 {
    width: 394px;
    height: 100px;
    display: block;
  }
</style>